import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { SouvenirsModel } from '../SouvenirsModel';
import { SouvenirsImagesModel } from '../SouvenirsImagesModel';
import { SouvenirsService } from '../souvenirs.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { CountriesService } from '../../MasterData/countries.service';
import { CountriesModel } from '../../MasterData/CountriesModel';
import { EvaluationSouvenorsModel } from '../EvaluationSouvenorsModel';
import { EvaluationSouvenirsService } from '../evaluation-souvenirs.service';
import { ReportModel } from '../../Reports/ReportModel';
import { ReportService } from '../../Reports/report.service';
import { ToastrService } from 'ngx-toastr';
@Component({
    // moduleId: module.id,
    selector: 'souvenir-details',
    templateUrl: 'souvenir-details.component.html',
    styleUrls: ['souvenir-details.component.scss']
})
export class SouvenirDetailsComponent implements OnInit {
    Menuoption = 'center';
    Settingicon = true
      projectDetails : any;
      projectGallaryConfig  = {"slidesToShow": 1,"fade": true, "slidesToScroll": 1,"arrows": false,"dots": false,"autoplay": true, "autoplaySpeed": 2000};
    declare lang: any;
  
      constructor(  
          public router: Router,
          private formBuilder : FormBuilder,
          private modelService :SouvenirsService,
          private CountriesService:CountriesService,
          private ReportService:ReportService,
          private toster:ToastrService,
          private EvaluationSouvenirsService:EvaluationSouvenirsService,
          private route: ActivatedRoute,
          ) {      this.id = +route.snapshot.paramMap.get("id");
         }
         id=0;
         ngOnInit() {
          this.lang = localStorage.getItem('theme_lang');
          debugger;
          if(this.id > 0)
          {
            debugger;
            this.modelService.getById(this.id).subscribe(data=>{
              this.modelObject=data;
              this.files=this.modelObject.souvenirImagesList;
              this.EvaluationSouvenirsService.GetAllBySouvenirId(this.id).subscribe(data=>{
                this.EvaluationSouvenorsList=data;
              })
              console.log("modelObject",this.rows)
            })
          }
          else{
          }
      }
      selectedIndex: number = 0;
      @Input()
      data:any;
      modelObject: SouvenirsModel = new SouvenirsModel();
      rows :SouvenirsModel[]= [];
      CountriesList:CountriesModel[]=[];
      files:SouvenirsImagesModel[]=[];
      EvaluationSouvenorsList:EvaluationSouvenorsModel[]=[];
      public picurl: string ='';
      editEnabled = true;
      EvaluationSovenireObject: EvaluationSouvenorsModel = new EvaluationSouvenorsModel();
      EvaluationSovenireForm: FormGroup = new FormGroup({
        id: new FormControl(),
        comment: new FormControl(),
        souvenirId: new FormControl(),
        numberOfStars: new FormControl(),
        userId: new FormControl(),
        date: new FormControl(),
        time: new FormControl(),
       
    });
      public Evaluation:EvaluationSouvenorsModel[]=[];
      public myComment: string ='';
      public myStars: number =0;
      public myTime: Date =new Date();
      public myDate: Date =new Date();
      Save() {
          debugger;
          this.EvaluationSovenireObject = new EvaluationSouvenorsModel();
          this.EvaluationSovenireObject.id = 0;
          this.EvaluationSovenireObject.comment = this.myComment;
          this.EvaluationSovenireObject.souvenirId = this.id;
          this.EvaluationSovenireObject.numberOfStars = this.myStars;
          this.EvaluationSovenireObject.date = this.myDate;
          this.EvaluationSovenireObject.time = this.myTime;
          this.EvaluationSovenireObject.userId = 0;
          this.EvaluationSovenireObject.isHide = false;

          console.log(this.modelObject);
          console.log(this.modelObject);
          this.EvaluationSouvenirsService.insert(this.EvaluationSovenireObject).subscribe((data) => {
            this.myComment='';
            this.myStars=0;
            this.ngOnInit();
            // this.router.navigate(["app/HR/List-Salaries-Manager"]);
          });
        }
        ReportObject:ReportModel=new ReportModel();
        ReportForm:FormGroup=new FormGroup({
        id: new FormControl(),
        message: new FormControl(),
        commentId: new FormControl(),
        userId: new FormControl(),
        });
        public message: string ='';
        commetId=0;
        setCommentId(commetId){
          this.commetId =commetId;
    
        }
  @ViewChild('closebutton') closebutton;

          SendReport() {
            debugger;
            this.ReportObject = new ReportModel();
            this.ReportObject.id = 0;
            this.ReportObject.message = this.message;
            this.ReportObject.commentId = this.commetId;
            this.ReportObject.userId = 0;
            this.ReportObject.Type = 'souvenirs';
            console.log(this.modelObject);
            this.ReportService.insert(this.ReportObject).subscribe((data) => {
              this.message='';
              this.commetId=0;
          this.closebutton.nativeElement.click();
              this.toster.success("Success")
              // this.ngOnInit();
            });
          }
  
  }
  
